export default {
    // 买家中心
    "buyerWeb":'https://buyer.shuibengcloud.com',
    // 买家中心查看需求
    "buyerMess": 'https://buyer.shuibengcloud.com/#/demand',
    // 卖家中心
    "sellerWeb":'https://seller.shuibengcloud.com',
    // 设计师中心
    "designerWeb":'',
    // "designerWeb":'http://localhost:8081',
    // 评审中心
    "reviewWeb":'https://review.shuibengcloud.com',

    "payUrl":'https://www.shuibengcloud.com/resource-pay/pay/',
}



// WEBPACK FOOTER //
// ./src/utils/url.js